var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHeaderHoverCampaign = function SvgIconHeaderHoverCampaign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DA613A",
    d: "M10 18.334c3.544 0 6.667-2.5 6.667-5.834s-2.5-5-3.334-5.833c-1.084-1.085-1.48-2.485-1.617-3.528-.092-.701-.774-1.194-1.347-.78-.941.681-2.168 1.97-2.869 4.308C6.965 8.452 7.5 10 7.5 10s-.833-.416-1.25-1.666a36 36 0 0 0-.358-1.014c-.311-.846-1.448-.836-1.715.024-.42 1.353-.844 3.037-.844 4.323 0 4.167 3.123 6.667 6.667 6.667"
  })));
};
export default SvgIconHeaderHoverCampaign;